import React, { useMemo } from "react";

import { AddNew } from "../../../../../components/svg/svgImageList";
import { AssignUserToProject } from "../../../../../services/authorization/Permissions";
import Button from "../../../../../components/button/Button";
import useModal from "../../../../../components/dialog/useModal";
import useThemeService from "../../../../../services/theme-service/ThemeService";
import { permissionsService } from "../../../../../services/authorization/UserPermissionsService";
import { ProjectUsersStorage } from "../../../../../services/user/ProjectUsersStorage";
import { AddExistingUsersModal } from "../DialogBoxes";

interface AddExistingUsersButtonProps {
  projectUsersStorage: ProjectUsersStorage;
}

export function AddExistingUsersButton({ projectUsersStorage }: AddExistingUsersButtonProps) {
  const { themeClass } = useThemeService();

  const { isVisible, toggleModal } = useModal();

  const assignUserToProjectDisabled = useMemo(
    () => !permissionsService.userHasPermissionTo(AssignUserToProject),
    []
  );

  return (
    <>
      <Button
        id="button-add-existing-user"
        icon={{
          svg: AddNew,
          textKey: "projects.AddExistingUsersButton.label",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-add-new"]),
        }}
        disabled={assignUserToProjectDisabled}
        onClick={toggleModal}
      />
      <AddExistingUsersModal
        isVisible={isVisible}
        toggleModal={toggleModal}
        projectUsersStorage={projectUsersStorage}
      />
    </>
  );
}
